<template>
    <div class="container">
        <h1 class="title">
            Profitable Recipes
        </h1>
        <h2 class="subtitle">
            A list of recipes that can be used to gain instant gold
        </h2>
        <b-message v-if="error" type="is-danger" has-icon>
            {{error}}
        </b-message>
        <b-table
                :data="recipes"
                :loading="loading"
                striped
                narrowed
                :default-sort="['totalProfit', 'desc']"
        >
            <template slot-scope="props">
                <b-table-column field="itemIconUrl" label="Icon">
                    <img class="image is-32x32" :src="props.row.itemIconUrl" alt="Item icon">
                </b-table-column>
                <b-table-column field="itemName" label="Item name" sortable>
                    {{ props.row.itemName }}
                </b-table-column>
                <b-table-column field="totalProfit" label="Profit" sortable>
                    <gold-amount :amount="props.row.totalProfit" />
                </b-table-column>
                <b-table-column field="craftCount" label="Craft count" sortable>
                    {{ props.row.craftCount }}
                </b-table-column>
                <b-table-column label="">
                    <b-button size="is-small" tag="router-link"
                              :to="'crafting?recipeid=' + props.row.recipeId + '&materialacquisition=' + calculatorBuyType" :disabled="!showDetails">
                        Show details
                    </b-button>
                </b-table-column>
            </template>
        </b-table>
    </div>
</template>

<script>
    import axios from 'axios'
    import GoldAmount from "@/components/GoldAmount";

    export default {
        name: 'recipe-list',
        components: {
            GoldAmount
        },
        data() {
            return {
                recipes: [],
                loading: false,
                error: "",
                buyType: 'instant'
            }
        },
        computed: {
            calculatorBuyType() {
                if (this.buyType === 'order') {
                    return 'buyorder';
                } else {
                    return this.buyType;
                }
            },
            showDetails() {
                return this.$store.state.permissions.permissions.includes("ShiniesCalculator");
            },
        },
        methods: {
            loadAsyncData() {
                this.buyType = this.$route.params.buy;
                this.loading = true;
                axios.get("/shinies/recipes/" + this.buyType).then(response =>
                {
                    this.recipes = response.data;
                    this.error = "";
                }).catch(error => {
                    this.recipes = [];
                    this.error = error;
                }).finally(() => {
                    this.loading = false;
                })
            }
        },
        mounted() {
            this.loadAsyncData();
        }
    }
</script>
